"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assignAll;
function assignAll(actions, stores) {
  if (Array.isArray(actions)) {
    return actions.map(function (action) {
      return action.assignTo(stores);
    });
  } else {
    return Object.keys(actions).reduce(function (assigns, action) {
      assigns[action] = actions[action].assignTo(stores);
      return assigns;
    }, {});
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-act/lib/assignAll.js
// module id = 1160
// module chunks = 0